import { AlertData } from "@/utils/Define";
import { createStore } from "vuex";

export default createStore({
    state: {
        token: "",
        userId: "", //玩家id
        nickName: "",   //玩家名称
        isLogin: 0, //是否登录 0:否 1:登录
        code: "", //邀请码
        gameUrl: "",  //进入游戏的链接
        userType: 1,  //用户类型
        version: 0, //强制进入用户版本 0:自动
        isShowPWA: false,    //是否显示pwa下载
        deferredPrompt: {}, //pwa对象
        accountInfo: {
            gold: 0,  //当前玩家余额
            vipLevel: 0,    //vip等级
            vipUpgradeRewardAmount: 0,  //vip对应的奖励金额
            rebateLevel: 0, //返利等级
            returnAmount: 0,    //返利等级对应的金额
            withdrawNum: 0, //提现次数
            extensionCode: '', // 分享码
        },
        isShowNewPlayer: false, //是否显示新手专属奖励弹窗
        isShowCashBackTip: false,   //是否显示返现提示
        isShowCashBackProp: false,  //退出游戏时  是否显示现金返现弹窗提示
        isShowInviteInfo: false, // 是否显示分享详情界面
        isUserDisbale: false,   //玩家是否被禁用
        alertData: {} as AlertData, // 通用提示信息
        isShowAlert: false, // 是否显示通用提示界面
        isShowMaskBg: false,    //是否显示遮罩
        isHor: false, // 是否需要横屏
    },
    getters: {

    },
    mutations: {},
    actions: {},
    modules: {},
});
